(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const header = document.querySelector('.hero-header');
    if (!header) return;

    const threshold = parseInt(header.dataset.threshold, 10) || 80;

    function onScroll() {
      header.classList.toggle('is-scrolled', window.scrollY > threshold);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-animate]');
    if (!sections.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    sections.forEach(function (el) {
      observer.observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // ── Variant selector ──────────────────────────────────────
  document.querySelectorAll('[data-product-form]').forEach(function(form) {
    var variantsData = JSON.parse(form.querySelector('[data-product-variants]').textContent);

    function getSelected() {
      var selected = {};
      form.querySelectorAll('[data-option-value].is-selected').forEach(function(btn) {
        selected[btn.dataset.optionPosition] = btn.dataset.optionValue;
      });
      form.querySelectorAll('select[data-option-position]').forEach(function(sel) {
        selected[sel.dataset.optionPosition] = sel.value;
      });
      return selected;
    }

    function findVariant(selected) {
      return variantsData.find(function(v) {
        return Object.keys(selected).every(function(pos) {
          return v['option' + pos] === selected[pos];
        });
      });
    }

    function updateUI(variant) {
      var idInput = form.querySelector('[data-variant-id]');
      if (idInput) idInput.value = variant.id;

      var priceEl = form.querySelector('[data-price]');
      if (priceEl) priceEl.textContent = variant.price;

      var compareEl = form.querySelector('[data-compare-price]');
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price !== variant.price) {
          compareEl.textContent = variant.compare_at_price;
          compareEl.removeAttribute('hidden');
        } else {
          compareEl.setAttribute('hidden', '');
        }
      }

      var addBtn = form.querySelector('[data-add-to-cart]');
      if (addBtn) {
        addBtn.disabled = !variant.available;
        var textEl = addBtn.querySelector('[data-btn-text]');
        if (textEl) {
          textEl.textContent = variant.available ? addBtn.dataset.addText : addBtn.dataset.soldOutText;
        }
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());

      if (variant.featured_media_id) {
        var mediaEl = document.querySelector('[data-media-id="' + variant.featured_media_id + '"]');
        var gallery = document.querySelector('.main-product__gallery');
        if (mediaEl && gallery) {
          gallery.scrollTo({ top: mediaEl.offsetTop, behavior: 'smooth' });
          document.querySelectorAll('.main-product__thumb').forEach(function(t) {
            t.classList.toggle('is-active', t.dataset.thumbId == variant.featured_media_id);
          });
        }
      }
    }

    form.querySelectorAll('[data-option-value]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var pos = btn.dataset.optionPosition;
        form.querySelectorAll('[data-option-position="' + pos + '"]').forEach(function(b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        var variant = findVariant(getSelected());
        if (variant) updateUI(variant);
      });
    });

    form.querySelectorAll('select[data-option-position]').forEach(function(sel) {
      sel.addEventListener('change', function() {
        var variant = findVariant(getSelected());
        if (variant) updateUI(variant);
      });
    });
  });

  // ── Quantity stepper ──────────────────────────────────────
  document.querySelectorAll('.quantity-stepper').forEach(function(stepper) {
    var input = stepper.querySelector('[data-quantity-input]');
    stepper.querySelector('[data-qty="decrease"]').addEventListener('click', function() {
      var val = parseInt(input.value, 10);
      if (val > 1) input.value = val - 1;
    });
    stepper.querySelector('[data-qty="increase"]').addEventListener('click', function() {
      input.value = parseInt(input.value, 10) + 1;
    });
  });

  // ── Collapsible tabs ──────────────────────────────────────
  document.querySelectorAll('.collapsible-tab__trigger').forEach(function(trigger) {
    var bodyId = trigger.getAttribute('aria-controls');
    var body = document.getElementById(bodyId);
    if (!body) return;

    trigger.addEventListener('click', function() {
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!isOpen));
      body.style.maxHeight = isOpen ? '0' : body.scrollHeight + 'px';
    });
  });

  // ── Thumbnail gallery ─────────────────────────────────────
  document.querySelectorAll('.main-product__thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var mediaId = thumb.dataset.thumbId;
      var mediaEl = document.querySelector('[data-media-id="' + mediaId + '"]');
      var gallery = document.querySelector('.main-product__gallery');
      if (mediaEl && gallery) {
        gallery.scrollTo({ top: mediaEl.offsetTop, behavior: 'smooth' });
      }
      document.querySelectorAll('.main-product__thumb').forEach(function(t) {
        t.classList.toggle('is-active', t === thumb);
      });
    });
  });

  // ── Share button ──────────────────────────────────────────
  document.querySelectorAll('[data-share-url]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var url = btn.dataset.shareUrl;
      var labelEl = btn.querySelector('[data-share-label]');
      var originalText = labelEl ? labelEl.textContent : '';
      var copiedText = btn.dataset.copiedText || 'Copied!';

      if (navigator.share) {
        navigator.share({ url: url });
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function() {
          if (labelEl) {
            labelEl.textContent = copiedText;
            setTimeout(function() { labelEl.textContent = originalText; }, 2000);
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
